/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RegisterScenarioEnum {
  Ok = 'Ok',
  OkButRequiresEmailValidation = 'OkButRequiresEmailValidation',
  AmbigousAccounts = 'AmbigousAccounts',
}
